module.exports = __webpack_public_path__ + "static/media/nyd-poster.ec3b03ef.jpg";